import SessionEventProto from "../session-event-proto";
// import SessionEventProto from "core/gd-session/session-event-proto";


export default class EventCompanyRoleChange extends SessionEventProto {

    process() {
        if (this.isDifferentCompany()) return false;

        if (this.companyId === gd.companyId) {
            // someone changed current user role in company (!)
            // const sessionResetRequest = ApiSession.fullReset(gd.companyId);

            gd.session.resetFull('EventCompanyRoleChange')


        }

    }
};


//
// module.exports = class EventCompanyRoleChange extends EventActionProto {
//
//     constructor(uid, data, fromSID, companyId) {
//         super(uid, data, companyId);
//     }
//
//     process() {
//         if (this.companyId === gd.companyId) {
//             // someone changed current user role in company (!)
//             const sessionResetRequest = ApiSession.fullReset(gd.companyId);
//         }
//     }
// };
